import React, { useState } from "react";
import { useUnifiedService } from "../../utilities/contexts/UnifiedServiceContext";

interface UnifiedResultsNavigationProps {
  showTryAgain?: boolean;
  tryAgainText?: string;
  className?: string;
}

const UnifiedResultsNavigation: React.FC<UnifiedResultsNavigationProps> = ({ showTryAgain = true, tryAgainText = "Try Again", className = "" }) => {
  const { resetAll } = useUnifiedService();
  const [isResetting, setIsResetting] = useState(false);

  const handleTryAgain = async () => {
    setIsResetting(true);

    setTimeout(() => {
      resetAll();
      setIsResetting(false);
    }, 300);
  };

  if (!showTryAgain) return null;

  return (
    <div className={`flex flex-col items-center w-full ${className}`}>
      <div className="text-center">
        <p className="text-sm text-gray-600">Want to try with different images or settings?</p>
      </div>
      <button
        onClick={handleTryAgain}
        disabled={isResetting}
        className={`flex items-center gap-2 px-8 py-3 text-sm font-medium transition-all duration-200 border rounded-lg
          ${isResetting ? "bg-gray-50 border-gray-200 text-gray-400 cursor-not-allowed" : "border-primary bg-primary text-white hover:bg-primary/90"}`}
      >
        <svg className={`w-5 h-5 ${isResetting ? "animate-spin" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span>{isResetting ? "Resetting..." : tryAgainText}</span>
      </button>
    </div>
  );
};

export default UnifiedResultsNavigation;
